import React from 'react';
import { T } from 'shared/helper/translate';
var OrderServicesWrapper = function OrderServicesWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Services ordered"
  })), children);
};
export default OrderServicesWrapper;